import Immutable from 'immutable';
import { PROGRESS_PAGE_SUCCESS } from '../Courses/CourseProgress/actions';
import { MODULE_SET_MANY } from './actions';
import { LOGOUT_SUCCESS } from '../Auth/actions';
import {
  FETCH_COURSE_MODULES_SUCCESS,
  CREATE_MODULE_TO_COURSE_MODULE_SET,
  DELETE_MODULE_FROM_COURSE,
  UPDATE_MODULE_DATA,
  SET_COURSE_MODULES,
} from '../Courses/actions';
import { id } from '../../web/utilities/functions';

const DEFAULT_STATE = Immutable.fromJS({
  byCoursePath: {
    /* coursePath: [] */
  },
});

export function Modules(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case MODULE_SET_MANY:
    case FETCH_COURSE_MODULES_SUCCESS:
    case PROGRESS_PAGE_SUCCESS: {
      const { modules, coursePath } = action;
      return state.setIn(
        ['byCoursePath', coursePath],
        Immutable.fromJS(modules)
      );
    }
    case CREATE_MODULE_TO_COURSE_MODULE_SET: {
      const { coursePath, newModule } = action;
      const immutableNewModule = Immutable.fromJS(newModule);
      // modules are always appended to the end of the moduleSet modules list
      return state.updateIn(
        ['byCoursePath', coursePath],
        Immutable.List(),
        (modules) => modules.push(immutableNewModule)
      );
    }
    case DELETE_MODULE_FROM_COURSE: {
      const { coursePath, moduleid: moduleId } = action;
      return state.updateIn(
        ['byCoursePath', coursePath],
        Immutable.List(),
        (modules) => modules.filter((m) => m.get('id') !== moduleId)
      );
    }
    case UPDATE_MODULE_DATA: {
      const { coursePath, moduleID, changes } = action;
      const immutableChanges = Immutable.fromJS(changes);
      return state.updateIn(
        ['byCoursePath', coursePath],
        Immutable.List(),
        (modules) =>
          modules.map((m) =>
            m.get('id') === moduleID ? m.merge(immutableChanges) : m
          )
      );
    }
    case SET_COURSE_MODULES: {
      const { coursePath, moduleIds } = action;
      let modules = Immutable.Map();
      state
        .getIn(['byCoursePath', coursePath], Immutable.List())
        .forEach((m) => {
          modules = modules.set(m.get('id'), m);
        });
      return state.setIn(
        ['byCoursePath', coursePath],
        Immutable.fromJS(moduleIds)
          .map((moduleId) => modules.get(moduleId, null))
          .filter(id)
      );
    }
    case LOGOUT_SUCCESS: {
      return DEFAULT_STATE;
    }
    default: {
      return state;
    }
  }
}
